import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import SectionUs3 from "./page_us/Solution-US-3/SectionUs3.js";
import { useEffect } from "react";




const PlafondsMursTendus = () =>{
     useEffect(() => {
  // ========= HELPERS =========
  const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  const setMetaProperty = (property, content) => {
    let tag = document.querySelector(`meta[property='${property}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("property", property);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= TITLE =========
  document.title =
    "Éclairage Décoratif Maroc | Ambiance LED & Design – UNIK SYSTEM";

  // ========= BASIC SEO =========
  setMeta(
    "description",
    "Éclairage décoratif LED au Maroc avec UNIK SYSTEM : solutions design pour créer des ambiances modernes et élégantes. Idéal pour maisons, hôtels et espaces professionnels."
  );

  setMeta(
    "keywords",
    "eclairage decoratif maroc, eclairage ambiance maroc, LED design maroc, lumiere decorative murale maroc, eclairage interieur moderne maroc, lighting design maroc, UNIK SYSTEM decoratif"
  );

  setMeta("robots", "index, follow");
  setMeta("author", "UNIK SYSTEM");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute(
    "href",
    "https://unik-system.com/eclairage-decoratif-maroc"
  );

  // ========= OPEN GRAPH =========
  setMetaProperty(
    "og:title",
    "Éclairage Décoratif Maroc – Ambiance LED | UNIK SYSTEM"
  );
  setMetaProperty(
    "og:description",
    "Créez une ambiance lumineuse moderne avec des solutions LED décoratives au Maroc."
  );
  setMetaProperty(
    "og:image",
    "https://unik-system.com/static/media/34Plafond%20architectural%20moderne.19248fbaedfa4a34ad0c.webp"
  );
  setMetaProperty(
    "og:url",
    "https://unik-system.com/eclairage-decoratif-maroc"
  );
  setMetaProperty("og:type", "website");
  setMetaProperty("og:locale", "fr_FR");

  // ========= TWITTER =========
  setMeta("twitter:card", "summary_large_image");
  setMeta(
    "twitter:title",
    "Éclairage Décoratif Maroc – UNIK SYSTEM"
  );
  setMeta(
    "twitter:description",
    "Solutions LED design pour ambiance moderne et élégante."
  );
  setMeta(
    "twitter:image",
    "https://unik-system.com/static/media/34Plafond%20architectural%20moderne.19248fbaedfa4a34ad0c.webp"
  );

  // ========= SCHEMA (LOCAL BUSINESS + SERVICE) =========
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "UNIK SYSTEM",
    url: "https://unik-system.com",
    description:
      "Spécialiste en éclairage décoratif LED et ambiance lumineuse au Maroc.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "MA",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Éclairage Décoratif",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Éclairage LED Ambiance"
          }
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Éclairage Décoratif Mural"
          }
        }
      ]
    }
  };

  let script = document.querySelector("#schema-us-light-decoratif");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-us-light-decoratif";
    document.head.appendChild(script);
  }
  script.innerHTML = JSON.stringify(schema);

  // ========= FAQ SCHEMA =========
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "C’est quoi l’éclairage décoratif ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "C’est un éclairage conçu pour créer une ambiance esthétique et mettre en valeur un espace."
        }
      },
      {
        "@type": "Question",
        name: "Où utiliser l’éclairage décoratif ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Dans les maisons, hôtels, restaurants et espaces commerciaux."
        }
      },
      {
        "@type": "Question",
        name: "Pourquoi choisir LED ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Les LED offrent une faible consommation, une longue durée de vie et un design moderne."
        }
      }
    ]
  };

  let faqScript = document.querySelector("#faq-schema-us-light-decoratif");
  if (!faqScript) {
    faqScript = document.createElement("script");
    faqScript.type = "application/ld+json";
    faqScript.id = "faq-schema-us-light-decoratif";
    document.head.appendChild(faqScript);
  }
  faqScript.innerHTML = JSON.stringify(faqSchema);

}, []);





  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs3/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;